import React, { useState, useCallback } from 'react';
// import { loadMessageFail, loadMessageHide } from '../../../redux/actions/notification'; // Uncommented based on usage
import assignmentsStyles from '@features/assignments/styles/assignment.module.scss';
// Assume SVG imports are correct
// import { ReactComponent as LikeIco } from '../../../images/icons/like.svg';
// import { ReactComponent as DisLikeIco } from '../../../images/icons/dislike.svg';
// import { ReactComponent as ComentIco } from '../../../images/icons/coment.svg';
import { AssignmentInput } from './AssignmentInput';
import { Assignment } from '@/api/timeAssignments/types';
import { ReprocessTaskModal } from './ReprocessTaskModal';

interface DayItem {
  date: string;
}

interface Props {
  assignment: Assignment;
  isEstimatedDisabled: boolean;
  isRealTimeDisabled: boolean;
  actionShowTaskDetail: () => void;
  estimatedTimes: { [date: string]: number };
  onEstimatedChange: (date: string, value: number) => void;
  weekDays: string[];
  setEditedRealTimes: React.Dispatch<React.SetStateAction<{ [scheduleId: string]: number }>>;
  // Nueva prop para validación
  validateHourInput?: (taskId: string, date: string, hours: number) => boolean;
}

export const AssignmentCalendarTask: React.FC<Props> = ({
  assignment,
  weekDays,
  isEstimatedDisabled,
  isRealTimeDisabled,
  actionShowTaskDetail,
  estimatedTimes,
  onEstimatedChange,
  setEditedRealTimes,
  validateHourInput
}) => {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const getCalendarTask = useCallback((day: DayItem) => {
    let realTime = -1;
    let estimatedTime = -1;
    let scheduleId = "";

    for (let j = 0; j < assignment?.schedules?.length; j++) {
      if (assignment.schedules[j].scheduleDate.substring(0, 10) === day.date) {
        realTime = Number((assignment.schedules[j].real_time || "0").replace(',', '.'));
        estimatedTime = Number((assignment.schedules[j].estimated_time || "0").replace(',', '.'));
        scheduleId = assignment.schedules[j].id?.toString() || `schedule-${j}`;
      }
    }

    if (!scheduleId) {
      scheduleId = `new-${assignment.task_id?.toString() || 'unknown'}-${day.date}`;
    }

    let valueE: number;
    if (typeof estimatedTimes[day.date] === "number") {
      valueE = estimatedTimes[day.date];
    } else if (estimatedTime === -1) {
      valueE = 0;
    } else {
      valueE = estimatedTime;
    }

    return (
      <AssignmentInput
        key={(day.date || "nodate") + (assignment.task_id?.toString() || "notaskid")}
        estimatedTime={valueE}
        scheduleId={scheduleId}
        onEstimatedChange={val => onEstimatedChange(day.date, val)}
        initclassnameE={assignmentsStyles[realTime === -1 && estimatedTime === -1 ? 'assigncalentask__empty' : 'assigncalentask__est']}
        isEstimatedDisabled={isEstimatedDisabled}
        initvalueRealTime={realTime === -1 ? 0 : realTime}
        initclassnameR={assignmentsStyles[realTime === -1 ? 'assigncalentask__empty' : 'assigncalentask__real']}
        isRealTimeDisabled={isRealTimeDisabled}
        setEditedRealTimes={setEditedRealTimes}
        taskId={assignment.task_id?.toString() || ''}
        date={day.date}
        validateHourInput={validateHourInput}
      />
    );
  },
    [
      assignment.task_id,
      assignment.schedules,
      isEstimatedDisabled,
      isRealTimeDisabled,
      estimatedTimes,
      onEstimatedChange,
      setEditedRealTimes,
      validateHourInput,
    ]);

  const lastSchedulesByDate: { [date: string]: typeof assignment.schedules[0] } = {};
  assignment.schedules.forEach((s) => {
    const date = s.scheduleDate.substring(0, 10);
    lastSchedulesByDate[date] = s;
  });
  const lastSchedules = Object.values(lastSchedulesByDate);

  return (
    <div className={assignmentsStyles['assigncalentask']}>
      <ReprocessTaskModal open={open} handleClose={handleClose} taskTitle={assignment.task_title} />
      
      {/* Primera columna: Información de la tarea */}
      <div className={assignmentsStyles['assigncalentask__col']}>
        <div className={assignmentsStyles['assigncalentask__members']}>
          <button 
            onClick={actionShowTaskDetail}
            title={assignment.task_title}
          >
            {assignment.task_title}
          </button>
          <span className={assignmentsStyles['assigncalentask__separator']}>&nbsp;</span>
        </div>
        <div className={assignmentsStyles['assigncalentask__arrow']}>
          <span className={assignmentsStyles['assigncalentask__arrow-label']}>EST</span>
          <span className={assignmentsStyles['assigncalentask__arrow-label']}>REAL</span>
        </div>
      </div>
      
      {/* Segunda columna: Días de la semana */}
      <div className={assignmentsStyles['assigncalentask__col']}>
        <div className={assignmentsStyles['assigncalentask__days-wrapper']}>
          {weekDays.map((date) => getCalendarTask({ date }))}
        </div>
      </div>

      {/* Tercera columna: Totales */}
      <div className={assignmentsStyles['assigncalentask__col']}>
        <div className={assignmentsStyles['assigncalentask__totals-wrapper']}>
          <div className={assignmentsStyles['assigncalentask__sum']}>
            {lastSchedules.reduce((acc, s) => acc + Number((s.estimated_time || "0").replace(',', '.')), 0).toFixed(1)}
          </div>
          <div className={assignmentsStyles['assigncalentask__sum-total']}>
            {lastSchedules.reduce((acc, s) => acc + Number((s.real_time || "0").replace(',', '.')), 0).toFixed(1)}
          </div>
        </div>
      </div>
    </div>
  );
};